import React from 'react';
import Box from '../../../components/Box';
import { DetailLayout } from '../../../components/DetailLayout';
import GlobalStateMessage from '../../../components/GlobalStateMessage';
import Typography from '../../../components/Typography';
import { translate } from '../../../i18n';
import { useAuthentication } from '../../../state/Authentication';
import RestartEmailFlow from './RestartEmailFlow';
import Link from '../../../components/Link';
import useConfig from '../../../hooks/config.hooks';

const EmailPending: React.FC = () => {
  const {
    state: { user },
  } = useAuthentication();
  const { CHANGE_EMAIL_URL } = useConfig();

  return (
    <DetailLayout
      title="accessKeys.email.pending.title"
      description="accessKeys.email.pending.intro"
      backAction="/gegevens"
      backLabel="accessKeys.overview.title"
    >
      <Box>
        <Typography variant="h2" as="h6" classNames="u-margin-bottom-xs">
          {translate('accessKeys.email.pending.subtitle')}
        </Typography>

        <GlobalStateMessage location="accessKeysEmail" />

        <Typography classNames="u-text-bold">
          {translate('accessKeys.email.pending.body1_title')}
        </Typography>
        <Typography classNames="u-margin-bottom">
          {translate('accessKeys.email.pending.body1', { email: user.email?.candidate! })}
        </Typography>

        <Typography classNames="u-text-bold">
          {translate('accessKeys.email.pending.body2_title')}
        </Typography>
        <Typography classNames={['u-margin-bottom']}>
          {translate('accessKeys.email.pending.body2.before')}
          <Link to={CHANGE_EMAIL_URL} target="_blank">
            {translate('accessKeys.email.pending.body2.link')}
          </Link>
        </Typography>
      </Box>

      <RestartEmailFlow />
    </DetailLayout>
  );
};

export default EmailPending;
